<template>
  <v-card>
    <v-card-title :class="color">
      <h1 class="white--text">
        <span :class="`botter-${channel}-icon`"></span>
        {{ capitalizeFirst(channel) }} App Config
      </h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <div v-for="(attr, i) in attrs" :key="i">
          <label>{{ formatName(attr) }}</label>
          <v-text-field
            v-model="input[attr]"
            :placeholder="formatName(attr)"
            outline
          />
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('closed')">Close</v-btn>
      <v-btn :class="[color, 'white--text']" @click="updateApp">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ChannelNotificationConfig",
  props: {
    id: {
      type: String,
      required: true,
    },
    attrs: {
      type: Array,
      required: true,
    },
    channel: {
      type: String,
      default: "Channel",
    },
    color: {
      type: String,
      default: "primary",
    },
  },
  data() {
    return {
      appData: null,
      input: {},
    };
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
  },
  mounted() {
    this.getApp();
  },
  methods: {
    async getApp() {
      this.$store.dispatch("setLoader", true);
      const { data } = await this.$http_session_manager.get(
        `/bots/apps/${this.channel}/${this.id}`
      );

      this.$store.dispatch("setLoader", false);
      if (data[`${this.channel}_apps`] && data[`${this.channel}_apps`].length) {
        this.appData = data[`${this.channel}_apps`][0];
        this.input = data[`${this.channel}_apps`][0];
      } else {
        throw new Error(`No ${this.channel} app found`);
      }
    },
    async updateApp() {
      this.$store.dispatch("setLoader", true);
      const payload = this.$_.omit(this.input, ["_id"]);
      const { data } = await this.$http_session_manager.put(
        `/bots/${this.botId}/apps/${this.channel}`,
        payload
      );

      this.$store.dispatch("setSnackbar", {
        text: `Updated Successfully`,
        color: "success",
      });

      this.$emit("success", data);
    },
    capitalizeFirst(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    formatName(name) {
      return name
        .split("_")
        .map((i) => this.capitalizeFirst(i))
        .join(" ");
    },
  },
};
</script>

<style lang="css" scoped></style>
